import { func, object } from 'prop-types';
import { path } from 'ramda';
import React from 'react';

import ContentColumns from '../../components/ContentColumns';
import TextFieldBox from 'components/TextFieldBox';

const View4 = (_, { fm, fmString, formValues, onChange }) => {
  const onChangeText = name => event => {
    const eventValue = path(['currentTarget', 'value'], event);
    onChange({ [name]: eventValue });
  };

  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fmString(`onlineRehabilitation.rehab4.4.header`)}</h2>
            <br />
            <div>{fm(`onlineRehabilitation.rehab4.4.text`)}</div>
            <br />

            <div>
              <h3>{fmString('onlineRehabilitation.rehab4.4.personToShowPlan')}</h3>
              <TextFieldBox
                editing
                input={{
                  value: path(['rehab4', 'personToShowPlan'], formValues) || '',
                  onChange: onChangeText('personToShowPlan'),
                  name: 'personToShowPlan',
                }}
                placeholder={fmString('onlineRehabilitation.rehab4.4.personToShowPlaceholder')}
              />
            </div>
          </div>
        }
      />
    </React.Fragment>
  );
};

View4.contextTypes = {
  fm: func,
  fmString: func,
  formValues: object,
  onChange: func,
};
export default View4;
